import cls from "classnames";
import axios from "axios";
import { useEffect, useState } from "react";
import ReviewCard from "./ReviewCard";
import ReviewSlider from "./ReviewSlider";
import * as Track from "@qoohoo/common/utils/analytics/track";
import { button, pageview } from "@qoohoo/common/constants/analytics";

const Reviews = ({ channelDetails }) => {
  const [reviews, setReviews] = useState([]);
  const [totalReviewCount, setTotalReviewCount] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(-1);
  const numberOfReviewsToShow = 4;
  const lastSlide =
    totalReviewCount % numberOfReviewsToShow === 0
      ? totalReviewCount / numberOfReviewsToShow - 1
      : Math.floor(totalReviewCount / numberOfReviewsToShow);

  const trackDetails = {
    current_screen: pageview.channel_details,
    url: `/by/${channelDetails.creator.username}`,
    uid: channelDetails.uid,
    name: channelDetails.name,
    "creator.uid": channelDetails.creator.uid,
    "creator.full_name": channelDetails.creator.fullname,
    "creator.username": channelDetails.creator.username,
    is_verified_creator: channelDetails.creator.is_verified_creator,
    total_review_count: totalReviewCount,
    current_slide: currentSlide,
  };

  function getReviews() {
    const offset = reviews.length * numberOfReviewsToShow;
    axios
      .post("/api/reviews/", {
        id: channelDetails.uid,
        offset,
        limit: numberOfReviewsToShow,
      })
      .then((res) => {
        const nextReviews = res.data.message.results;
        if (res.data.message.count >= offset && nextReviews.length > 0) {
          setReviews([...reviews, [...nextReviews]]);
          setTotalReviewCount(res.data.message.count);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setCurrentSlide((currentSlide) => {
          if (currentSlide === -1) return 0;
          return currentSlide + 1;
        });
      });
  }

  useEffect(() => {
    getReviews();
  }, []);

  return (
    channelDetails.total_number_of_reviews > 0 && (
      <div className="mt-12 sm:mt-14 md:mt-16">
        <h2 className="mb-3 text-xl font-medium sm:mb-4 sm:text-2xl font-inter">
          {reviews[0] && reviews[0].is_testimonial ? "Testimonials" : "Reviews"}
        </h2>
        <div className="space-x-4 text-[#BEBFBF] font-medium flex">
          <div>
            <span className="text-lg text-white sm:text-xl font-inter">
              {Math.ceil(channelDetails.average_rating * 2)}/10
            </span>{" "}
            <span className="text-xs sm:text-sm font-inter">
              people are liking this
            </span>
          </div>
          <div className="text-lg sm:text-xl">.</div>
          <div>
            <span className="text-lg text-white sm:text-xl font-inter">
              {channelDetails.total_number_of_reviews}
            </span>{" "}
            <span className="text-xs sm:text-sm font-inter">
              {reviews[0] && reviews[0].is_testimonial
                ? "testimonials"
                : "reviews"}
            </span>
          </div>
        </div>
        <div className="flex space-x-3 overflow-y-auto md:hidden md:space-x-0 md:overscroll-y-none">
          <ReviewSlider
            reviews={reviews.reduce((acc, curr) => [...acc, ...curr], [])}
            totalReviewCount={totalReviewCount}
            getReviews={getReviews}
          />
        </div>
        {/* <ReviewSwiper
          reviews={reviews}
          totalReviewCount={totalReviewCount}
          getReviews={getReviews}
        /> */}
        <div className="hidden w-full overflow-x-hidden md:flex flex-col">
          <ul
            className={cls(
              "flex pr-0 mt-6 -mr-0 space-x-3 md:space-x-0 md:space-y-4 md:flex-col hide-scrollbar sm:-mr-8 md:-mr-0 sm:pr-8 md:pr-0 review-slide"
            )}
          >
            {reviews[currentSlide]?.map((review, id) => {
              return <ReviewCard key={review.uid} review={review} />;
            })}
          </ul>
        </div>
        <div className="items-center justify-between hidden mt-3 lg:mt-5 transition-all md:flex">
          {currentSlide !== 0 && (
            <button
              onClick={() => {
                if (reviews.length > 1) {
                  Track.buttonClick(button.prev_review, {
                    ...trackDetails,
                    prev_slide: currentSlide - 1,
                  });
                  setCurrentSlide(currentSlide - 1);
                }
              }}
              className="h-10 w-10 rounded-full bg-[#22272B] flex items-center justify-center mr-auto"
            >
              <img
                src="/assets/icons/chevron-down.svg"
                alt="previous reviews button"
                className="rotate-90 select-none"
              />
            </button>
          )}
          {totalReviewCount > 3 && currentSlide !== lastSlide && (
            <button
              onClick={() => {
                if (
                  Math.ceil(totalReviewCount / numberOfReviewsToShow) ===
                  reviews.length
                ) {
                  Track.buttonClick(button.next_review, {
                    ...trackDetails,
                    next_slide: currentSlide + 1,
                  });
                  setCurrentSlide(currentSlide + 1);
                } else {
                  getReviews();
                }
              }}
              className={cls(
                "h-10 w-10 rounded-full bg-[#22272B] flex items-center justify-center ml-auto"
              )}
            >
              <img
                src="/assets/icons/chevron-down.svg"
                alt="next reviews button"
                className="-rotate-90 select-none"
              />
            </button>
          )}
        </div>
      </div>
    )
  );
};

export default Reviews;
